import React from 'react';

export const CrayonSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.2 30.3999L12.8 31.7999L12 32.5999C11.6 32.9999 11 32.9999 10.6 32.5999C9.9 31.8999 2.6 35.6999 2.1 35.9999L0 33.8999C0.2 33.3999 4.1 26.0999 3.4 25.3999C3 24.9999 3 24.3999 3.4 23.9999L4.2 23.2999L5.6 21.8999L14.2 30.3999Z" fill={color} />
        <path d="M23.5 3.9L7 20.4L15.6 29L32.1 12.5L23.5 3.9ZM12.5 23.8C11 22.3 13 17.8 17 13.8C21 9.8 25.5 7.8 27 9.3C28.5 10.8 26.5 15.3 22.5 19.3C18.4 23.3 14 25.3 12.5 23.8ZM35.7 7.5L28.5 0.3C28.1 -0.1 27.5 -0.1 27.1 0.3L26.4 1L25 2.4L33.6 11L35 9.6L35.7 8.9C36.1 8.5 36.1 7.9 35.7 7.5Z" fill={color} />
        <path d="M26.4002 1L25.0002 2.4L33.6002 11L35.0002 9.6L26.4002 1ZM23.5002 3.9L7.0002 20.4L15.6002 29L32.1002 12.5L23.5002 3.9ZM12.5002 23.8C11.0002 22.3 13.0002 17.8 17.0002 13.8C21.0002 9.8 25.5002 7.8 27.0002 9.3C28.5002 10.8 26.5002 15.3 22.5002 19.3C18.4002 23.3 14.0002 25.3 12.5002 23.8ZM5.6002 21.8L4.2002 23.2L12.8002 31.8L14.2002 30.4L5.6002 21.8Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18848)">
        <path d="M35.702 7.47675L28.522 0.29775C28.126 -0.09925 27.484 -0.09925 27.086 0.29775L3.395 23.9888C2.998 24.3857 2.998 25.0268 3.395 25.4258C4.115 26.1448 0.255 33.3848 0 33.9217L2.068 35.9997C2.604 35.7447 9.853 31.8847 10.574 32.6047C10.971 33.0017 11.613 33.0017 12.01 32.6047L35.702 8.91275C36.099 8.51675 36.099 7.87375 35.702 7.47675Z" fill="#E41D1D" />
        <path d="M4.13916 23.2407L26.4072 0.972656L35.0272 9.59266L12.7592 31.8607L4.13916 23.2407Z" fill="#FE6363" />
        <path d="M23.5342 3.84591L24.9712 2.40991L33.5912 11.0299L32.1542 12.4659L23.5342 3.84591ZM5.57617 21.8029L7.01217 20.3659L15.6322 28.9859L14.1952 30.4229L5.57617 21.8029Z" fill={window?.settings?.secondary_color ?? '#04333b'} />
        <path d="M26.8862 9.35364C25.3652 7.83264 20.9042 9.82964 16.9192 13.8126C12.9362 17.7966 10.9402 22.2586 12.4602 23.7796C13.9802 25.3006 18.4432 23.3036 22.4272 19.3206C26.4102 15.3366 28.4062 10.8736 26.8862 9.35364Z" fill="#E41D1D" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18848">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}